import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'cookie-banner',
    templateUrl: './cookie-banner.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule]
})
export class CookieBannerComponent {
    showBanner: boolean = false;

    /**
     * Constructor
     */
    constructor() {
        // Check if the user has already accepted the cookies
        if (!localStorage.getItem('cookieConsent')) {
            this.showBanner = true;
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Accept cookies
     */
    accept(): void {
        // Save the consent in the local storage
        localStorage.setItem('cookieConsent', 'true');

        // Hide the banner
        this.showBanner = false;
    }
}
